/* run_audit2.icon.svg.js */

module.exports = {
    icon: `    
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 969.000000 969.000000">
                <g transform="translate(0.000000,969.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
                    <path class="foreground-gl" d="M4770 9674 c-669 -42 -1254 -478 -1480 -1105 l-32 -88 -652 -3 c-630
            -4 -654 -4 -727 -25 -188 -53 -313 -127 -440 -261 -129 -136 -210 -296 -239
            -474 -14 -88 -14 -6802 0 -6917 49 -385 320 -687 700 -776 57 -13 404 -15
            2951 -15 2820 0 2888 0 2961 19 179 46 311 124 439 259 129 136 210 296 239
            474 14 88 14 6802 0 6917 -43 339 -266 624 -580 740 -149 55 -138 54 -810 58
            l-625 4 -29 82 c-44 123 -148 321 -222 421 -313 422 -777 668 -1299 689 -55 2
            -125 2 -155 1z m305 -678 c151 -29 177 -36 245 -68 36 -16 85 -40 110 -51 64
            -30 245 -214 303 -307 93 -152 141 -302 157 -490 5 -63 10 -121 10 -127 0 -10
            129 -13 610 -13 l610 0 -5 -37 c-2 -21 -9 -78 -15 -128 -63 -523 -260 -806
            -613 -879 -67 -14 -256 -16 -1665 -16 -1551 0 -1591 0 -1666 20 -281 72 -447
            273 -535 650 -20 84 -51 306 -51 364 l0 29 333 -7 c182 -3 461 -9 620 -13
            l287 -6 0 69 c0 269 143 583 343 756 155 134 376 239 557 267 89 13 257 7 365
            -13z m-242 -4447 c909 -540 1658 -987 1664 -993 15 -13 170 81 -1812 -1096
            -808 -480 -1480 -880 -1492 -888 l-23 -14 0 1986 c0 1092 3 1986 6 1986 3 0
            749 -442 1657 -981z" />
                </g>
            </svg>
         `
};
